import { UTM_FIELDS, UtmField } from "./prepForm.constants";

// Browser-only helpers, all guarded for SSR.

const UTM_STORAGE_KEY = "jag_prep_utms";

const isBrowser = (): boolean => typeof window !== "undefined";

export const getCookie = (name: string): string => {
  if (!isBrowser() || typeof document === "undefined") return "";
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : "";
};

export const getHubspotUtk = (): string => getCookie("hubspotutk");

type UtmValues = Partial<Record<UtmField, string>>;

// Persists utm_* from the landing URL in sessionStorage, since the pop-up may submit from a later page.
export const captureAndGetUtms = (): UtmValues => {
  if (!isBrowser()) return {};

  let stored: UtmValues = {};
  try {
    stored = JSON.parse(window.sessionStorage.getItem(UTM_STORAGE_KEY) || "{}");
  } catch {
    stored = {};
  }

  const params = new URLSearchParams(window.location.search);
  const fromUrl: UtmValues = {};
  UTM_FIELDS.forEach(field => {
    const value = params.get(field);
    if (value) fromUrl[field] = value;
  });

  const merged = { ...stored, ...fromUrl };
  if (Object.keys(fromUrl).length) {
    try {
      window.sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(merged));
    } catch {
      /* blocked storage — use the in-memory merge */
    }
  }
  return merged;
};

export const toE164AU = (raw: string): string => {
  const cleaned = (raw || "").replace(/[^\d+]/g, "");
  if (!cleaned) return "";
  if (cleaned.startsWith("+")) return cleaned;
  if (cleaned.startsWith("0")) return `+61${cleaned.slice(1)}`;
  if (cleaned.startsWith("61")) return `+${cleaned}`;
  return `+61${cleaned}`;
};

export const isValidAUMobile = (e164: string): boolean => /^\+61\d{9}$/.test(e164);

export const isValidEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
